import React from 'react';
import { Link } from 'react-router-dom';
import artizationLogo from '../images/artization_logo.png';

function Footer() {
  return (
    <footer className="relative w-full h-auto overflow-hidden border-t border-black/10 bg-[#f3f0ea] text-[#191e22] lg:pl-20">
      <div
        className="w-full absolute top-0 left-0 right-0"
        style={{
          height: '3px',
          background: 'linear-gradient(to right, #191e22 0%, #b85c43 50%, #191e22 100%)',
        }}
      />
      <div className="w-full overflow-hidden px-4 pt-8 md:px-10 md:pt-10">
        <img
          src={artizationLogo}
          alt="Artization"
          className="mx-auto w-full max-w-5xl opacity-[0.08]"
        />
      </div>
      <div
        className="mx-auto mb-8 w-[calc(100%-2rem)] max-w-7xl border-t border-black/10"
        style={{
          height: '1px',
        }}
      />
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6 md:gap-0 px-4 md:px-8 pb-8 md:pb-8 pt-0">
        <div className="flex flex-col justify-between items-center text-center text-[#191e22]/70">
          <p className="font-semibold text-sm md:text-md">Artization Technology 2026 ®</p>
          <address className="not-italic text-xs md:text-sm">
            Darlinghurst, 2010 – Sydney, Australia
          </address>
        </div>
        <nav className="flex-1 w-full">
          <ul className="flex flex-wrap md:flex-row justify-center gap-x-6 gap-y-3 md:gap-16 headFont text-xs md:text-base font-semibold uppercase tracking-wide text-[#191e22]">
            <li>
              <Link to="/#top" className="transition-colors hover:text-[#b85c43]">
                Home
              </Link>
            </li>
            <li>
              <Link to="/#explore" className="transition-colors hover:text-[#b85c43]">
                Explore
              </Link>
            </li>
            <li>
              <Link to="/#analytics" className="transition-colors hover:text-[#b85c43]">
                Analytics
              </Link>
            </li>
            <li>
              <Link to="/#articles" className="transition-colors hover:text-[#b85c43]">
                Articles
              </Link>
            </li>
            <li>
              <Link to="/#features" className="transition-colors hover:text-[#b85c43]">
                Features
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
